import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { MEDIA_PROPS_LIST, SCREEN_SIZES } from 'aria-viewer/tour/constants'
import AspectHelper from 'aria-viewer/media/components/aspectHelper'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import colors from 'aria-viewer/tour/constants/style/colors'
import {
    showSupplementalMediaView,
    showSupplementalMediaPreview,
} from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import Button from 'aria-viewer/tour/components/buttons/button'
import {
    supplementalMediaCarouselMediasLength,
    supplementalMediaCarouselMediaByIndex,
} from 'aria-viewer/utils/functions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import MobileDetect from 'aria-viewer/utils/mobileDetect'
import StopCardStates from 'aria-viewer/stopselector/constants/StopCardStates'
import { MAIN_SUPPLEMENTAL_MEDIA_BUTTON } from 'aria-viewer/keyboard/constants/tabIndices'

const ButtonStyle = {
    width: '3.5em',
    height: '3.2em',
    position: 'relative',
    transform: 'translate3d(0,0,1px)',
}

const LowerPicture = {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    transform: 'rotate(3deg) translate3d(0,0,1px)',
    border: '2px solid white',
    position: 'absolute',
    left: 5,
    top: 5,
    background: 'white',
}

const HigherPicture = {
    border: '2px solid white',
    position: 'absolute',
    left: 0,
    top: 0,
    background: 'white',
    transform: 'translate3d(0,0,1px)',
}

const Counter = {
    width: '1.55em',
    height: '1.55em',
    backgroundColor: styleguide.colors.teal,
    position: 'absolute',
    right: 0,
    bottom: 0,
    borderRadius: '50%',
    textAlign: 'center',
    color: colors.white,
    transform: 'translate3d(0,0,1px)',
}

const CounterFont = {
    fontSize: '0.9em',
    fontWeight: 'bold',
}

const CounterNumber = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%) translate3d(0,0,1px)',
}

const PictureSizes = {
    width: '2.7em',
    height: '2.35em',
}

const getThumbnailStyle = ({ sizes, url }) => {
    return {
        width: sizes.width,
        height: sizes.height,
        backgroundImage: `url("${url}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
        border: 'solid 2px #ffffff',
        backgroundColor: '#818181',
        transitionProperty: 'background',
        transitionDuration: '300ms',
        transitionTimingFunction: 'ease-in',
        transitionDelay: '100ms',
    }
}

class SupplementalMediaButton extends PureComponent {
    static defaultProps = {
        hideLowerPicture: false,
        ignoreUnmount: false,
        style: {},
    }

    constructor(props) {
        super(props)
        this.state = { visible: 0 }
    }

    calculateStopCardsState = props => {
        const sourceProps = props || this.props

        const { stopCardsState, mainMediaInitialized, altMainMedia, isHotspotModalOpen } = sourceProps

        return !altMainMedia && !isHotspotModalOpen && mainMediaInitialized ? stopCardsState : StopCardStates.HIDE
    }

    shouldComponentUpdate(nextProps, nextState) {
        const suppUrls = this.props.supplementalMediaCarouselMediaByIndex.urls || {}
        const nextSuppUrls = this.props.supplementalMediaCarouselMediaByIndex.urls || {}

        return (
            this.state.visible !== nextState.visible ||
            suppUrls.tiny !== nextSuppUrls.tiny ||
            this.props.supplementalMediaCarouselMediasLength !== nextProps.supplementalMediaCarouselMediasLength ||
            this.state.hover !== nextState.hover ||
            (!!this.props.style.pictureSizes &&
                this.props.style.pictureSizes.width !== nextProps.style.pictureSizes.width) ||
            this.props.style.containerStyle != nextProps.style.containerStyle
        )
    }

    init = (props, nextProps, state, nextState) => {
        const self = this
        const sizes = Object.assign({}, PictureSizes, nextProps.style.pictureSizes)
        const hasPreviewHidden = props.supplementalMediaPreviewVisible && !nextProps.supplementalMediaPreviewVisible
        const suppUrls = props.supplementalMediaCarouselMediaByIndex.urls || {}
        const nextSuppUrls = nextProps.supplementalMediaCarouselMediaByIndex.urls

        // supplemental media button is visible if we are at the current stop, and the stop cards state is lowered
        // we grab the discrete stopCardsState by checking what they will be in nextProps
        // (TODO : this will change when we add discrete actions/data model state for stopCardsUI)
        const nextIsVisible =
            nextProps.index == nextProps.stopIndex && this.calculateStopCardsState(nextProps) == StopCardStates.LOWER

        if (
            nextSuppUrls !== undefined &&
            (props === nextProps ||
                suppUrls.tiny !== nextSuppUrls.tiny ||
                (props.style.pictureSizes && props.style.pictureSizes.width !== nextProps.style.pictureSizes.width))
        ) {
            this.picture = <div style={getThumbnailStyle({ sizes, url: nextSuppUrls.tiny })} />
        }

        clearTimeout(self.timeout)

        if ((nextIsVisible && !state.visible) || hasPreviewHidden) {
            self.timeout = setTimeout(() => {
                self.setState({ visible: 1 })
            }, hasPreviewHidden ? 300 : 600)
        } else if ((!nextIsVisible && state.visible) || nextProps.supplementalMediaPreviewVisible) {
            this.setState({ visible: 0 })
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    componentWillMount() {
        this.init(this.props, this.props, this.state, this.state)
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.init(this.props, nextProps, this.state, nextState)
    }

    handleOnClick = e => {
        return showSupplementalMediaView({ stopid: this.props.currentStop.stopid })
    }

    onMouseOver = () => {
        const { showSupplementalMediaPreview, screenSizes } = this.props

        //if it's mobile or screen width smaller than 1024 don't show hover preview
        if (MobileDetect.mobile() || screenSizes.width <= SCREEN_SIZES.size_1024) return

        return showSupplementalMediaPreview(true)
    }

    addLowerPicture = () => {
        const {
            supplementalMediaCarouselMediasLength: { mediaCount },
            hideLowerPicture,
        } = this.props
        return mediaCount > 1 && !hideLowerPicture && <div style={LowerPicture}>{this.picture}</div>
    }

    addCounter = () => {
        const {
            supplementalMediaCarouselMediasLength: { mediaCount },
            style: { counterStyle, counterFontStyle },
        } = this.props

        return (
            mediaCount > 1 && (
                <div style={{ ...Counter, ...counterStyle }}>
                    <div style={CounterNumber}>
                        <div style={{ ...CounterFont, ...counterFontStyle }} aria-label="View supplemental media">
                            {mediaCount}
                        </div>
                    </div>
                </div>
            )
        )
    }

    getSizes = () => {
        const height = horizontalViewSizes.height * 0.14

        return { height, width: height * 1.47, MARGIN: 8 }
    }

    button = () => {
        const {
            style: { buttonStyle, higherPicture },
        } = this.props

        return (
            <Button
                tabIndex={MAIN_SUPPLEMENTAL_MEDIA_BUTTON}
                style={{
                    ...ButtonStyle,
                    ...buttonStyle,
                }}
                onDispatchClick={this.handleOnClick}
                onMouseOver={this.onMouseOver}
                alt="supplemental media"
            >
                {this.addLowerPicture()}
                <div
                    style={{
                        ...HigherPicture,
                        ...higherPicture,
                    }}
                >
                    {this.picture}
                </div>
                {this.addCounter()}
            </Button>
        )
    }

    render() {
        const {
            supplementalMediaCarouselMediasLength: { mediaCount },
            style: { containerStyle },
            ignoreUnmount,
        } = this.props

        return (
            <OpacityHelper
                test={this.state.visible && mediaCount > 0}
                ignoreUnmount={ignoreUnmount}
                style={containerStyle}
            >
                {this.button}
            </OpacityHelper>
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'currentStop',
        'stopIndex',
        'stopCardsState',
        'isHotspotModalOpen',
        'altMainMedia',
        'mainMediaInitialized',
        'supplementalMediaPreviewVisible',
        'supplementalMediaCarouselMediaByIndex',
        'supplementalMediaCarouselMediasLength',
    ]),
    {
        showSupplementalMediaPreview,
    }
)(SupplementalMediaButton)
